
import { useState } from "react";
import { SearchBar } from "./search/SearchBar";
import { SkillsFilter } from "./search/SkillsFilter";
import { StatusFilter } from "./search/StatusFilter";
import { FunctionFilter } from "./search/FunctionFilter";
import { FilterBadges } from "./search/FilterBadges";

interface CandidatesSearchProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  skillsFilter: string[];
  setSkillsFilter: (skills: string[]) => void;
  statusFilter: string[];
  setStatusFilter: (status: string[]) => void;
  functionFilter: string;
  setFunctionFilter: (functionName: string) => void;
  allSkills: string[];
  allStatuses: string[];
}

export const CandidatesSearch = ({ 
  searchTerm, 
  setSearchTerm,
  skillsFilter,
  setSkillsFilter,
  statusFilter,
  setStatusFilter,
  functionFilter,
  setFunctionFilter,
  allSkills,
  allStatuses
}: CandidatesSearchProps) => {
  
  // Toggle skill selection
  const toggleSkill = (skill: string) => {
    if (skillsFilter.includes(skill)) {
      setSkillsFilter(skillsFilter.filter(s => s !== skill));
    } else {
      setSkillsFilter([...skillsFilter, skill]);
    }
  };
  
  // Toggle status selection
  const toggleStatus = (status: string) => {
    if (statusFilter.includes(status)) {
      setStatusFilter(statusFilter.filter(s => s !== status));
    } else {
      setStatusFilter([...statusFilter, status]);
    }
  };

  // Clear all filters
  const clearAllFilters = () => {
    setSkillsFilter([]);
    setStatusFilter([]);
    setFunctionFilter("");
  };

  return (
    <div className="mb-6">
      <div className="flex flex-col sm:flex-row gap-3">
        <SearchBar 
          searchTerm={searchTerm} 
          setSearchTerm={setSearchTerm} 
        />
        
        <div className="flex gap-2">
          <SkillsFilter 
            skillsFilter={skillsFilter} 
            setSkillsFilter={setSkillsFilter} 
            allSkills={allSkills} 
          />
          
          <StatusFilter 
            statusFilter={statusFilter} 
            setStatusFilter={setStatusFilter} 
          />
          
          <FunctionFilter 
            functionFilter={functionFilter} 
            setFunctionFilter={setFunctionFilter} 
          />
        </div>
      </div>
      
      <FilterBadges
        skillsFilter={skillsFilter}
        toggleSkill={toggleSkill}
        statusFilter={statusFilter}
        toggleStatus={toggleStatus}
        functionFilter={functionFilter}
        setFunctionFilter={setFunctionFilter}
        clearAllFilters={clearAllFilters}
      />
    </div>
  );
};
